import { api } from "@/api/client";

export interface ContractView {
  id: string;
  connection_id: string;
  marketplace: string;
  organization_ref: string;
  organization_name: string;
  // ⚠️ Комиссия и склад — взаимоисключающие тройки: у `transfer`-маркетплейса
  // (Яндекс) контрагента и договора нет по построению, товар всё время
  // оставался нашим на складе-зеркале.
  kontragent_ref: string | null;
  kontragent_name: string | null;
  dogovor_ref: string | null;
  dogovor_name: string | null;
  warehouse_ref: string | null;
  warehouse_name: string | null;
  memo_recipient_role: string | null;
  memo_recipient_name: string | null;
  created_at: string;
  updated_at: string;
}

export interface ContractCreate {
  connection_id: string;
  marketplace: string;
  organization_ref: string;
  organization_name: string;
  kontragent_ref?: string | null;
  kontragent_name?: string | null;
  dogovor_ref?: string | null;
  dogovor_name?: string | null;
  warehouse_ref?: string | null;
  warehouse_name?: string | null;
  memo_recipient_role?: string | null;
  memo_recipient_name?: string | null;
}

export interface ContractUpdate {
  organization_name?: string;
  kontragent_ref?: string | null;
  kontragent_name?: string | null;
  dogovor_ref?: string | null;
  dogovor_name?: string | null;
  warehouse_ref?: string | null;
  warehouse_name?: string | null;
  memo_recipient_role?: string | null;
  memo_recipient_name?: string | null;
}

export async function listContracts(connectionId?: string): Promise<ContractView[]> {
  const { data } = await api.get<ContractView[]>("/marketplace-contracts", {
    params: connectionId ? { connection_id: connectionId } : undefined,
  });
  return data;
}

export async function createContract(body: ContractCreate): Promise<ContractView> {
  const { data } = await api.post<ContractView>("/marketplace-contracts", body);
  return data;
}

export async function updateContract(
  id: string,
  body: ContractUpdate,
): Promise<ContractView> {
  const { data } = await api.put<ContractView>(`/marketplace-contracts/${id}`, body);
  return data;
}

export async function deleteContract(id: string): Promise<void> {
  await api.delete(`/marketplace-contracts/${id}`);
}
